export default __webpack_public_path__ + "static/media/chart.622b6ab2.png";